import { useMutation } from "@apollo/client";
import { CONFIRM_MESSAGE_READ } from "../../graphql/mutations/DirectMessageContext";

const extractResult = (data) => data?.directMessageContext?.confirmMessageRead;

const useDirectMessageReadConfirmation = ({ onCompleted, onError } = {}) => {

  const [confirmMessageReadMutation, { data, error, loading }] = useMutation(
    CONFIRM_MESSAGE_READ,
    {
      errorPolicy: "none",
      onCompleted: (data) => {
        const result = extractResult(data);
        console?.info("** useDirectMessageReadConfirmation - completed", { result });
        onCompleted?.(result);
      },
      onError: (error) => {
        console?.error("** useDirectMessageReadConfirmation - error", { error });
        onError?.(error);
      },
    }
  );

  const executeConfirmMessageReadMutation = async (messageId) => (
    await confirmMessageReadMutation({
      variables: {
        messageId
      }
    })
  );

  return [
    executeConfirmMessageReadMutation,
    {
      data: extractResult(data),
      error,
      loading,
    }
  ];

};

export default useDirectMessageReadConfirmation;
